module.exports = __webpack_public_path__ + "img/programme.6b5ba80f.png";